export const usePrintStorage = () => {
  const setPrintData = (printData: PrintParams) => {
    localStorage.setItem("print-data", JSON.stringify(printData));
  };

  const resetPrintData = () => {
    localStorage.removeItem("print-data");
  };

  const getPrintData = () => {
    const printData = localStorage.getItem("print-data");
    return printData ? (JSON.parse(printData) as PrintParams) : undefined;
  };

  return { getPrintData, setPrintData, resetPrintData };
};
